import mask from 'jquery-mask-plugin';

document.addEventListener('DOMContentLoaded', function () {
    $('[phone]').mask('(00) 00000-0000');
    $("#formulario-circuito").on("submit", function (e) {
        e.preventDefault();
        formSubmit($(this))
    });
    // Verifica se o Swiper está carregado
    if (typeof Swiper === 'undefined') {
        console.error('❌ Swiper.js v10 não foi carregado!');
        return;
    }

    const swiperEl = document.querySelector('.slide-depoimentos');
    if (!swiperEl) {
        console.error('❌ Elemento .slide-depoimentos não encontrado!');
        return;
    }

    try {
        const swiper = new Swiper('.slide-depoimentos', {
            // Configurações principais
            slidesPerView: 2,
            spaceBetween: 24,
            loop: true,
            speed: 500,

            // Pagination (dots)
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: false,
            },

            // Observa mudanças no DOM (útil para imagens/lazy load)
            observer: true,
            observeParents: true,
            observeSlideChildren: true,

            // Responsivo
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 16
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 32
                }
            }
        });

        console.log('✅ Swiper v10 inicializado!', swiper);

    } catch (error) {
        console.error('❌ Erro ao inicializar Swiper v10:', error);
    }

    // Scroll suave do CTA "Liberar conteúdo" até o formulário no topo
    const gateCta = document.querySelector('#gated-overlay .btn-default');
    const formTarget = document.getElementById('cadastre-se');

    if (gateCta && formTarget) {
        gateCta.addEventListener('click', function (e) {
            e.preventDefault();

            const headerEl = document.getElementById('header');
            const offset = (headerEl && headerEl.classList.contains('sticky'))
                ? headerEl.offsetHeight + 20
                : 20;
            const top = formTarget.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({ top: top, behavior: 'smooth' });
        });
    }

    // Inicializa o filtro de vídeos
    initVideoFilter();

    // btn wpp 
    const btnWpp = document.querySelector(".btn-wpp");

    if (btnWpp) {
        // esconde inicialmente
        btnWpp.classList.remove('d-block');
        btnWpp.classList.add('d-none');

        setTimeout(() => {
            // mostra após 30s
            btnWpp.classList.remove('d-none');
            btnWpp.classList.add('d-block');
        }, 30000); // 30000ms = 30s
    }

    const form = $('#formulario-circuito');
    const submitBtn = form.find('button[type="submit"]');

    submitBtn.prop('disabled', true);

    function checkFields() {
        let allFilled = true;

        form.find('input, select, textarea').each(function () {
            const field = $(this);
            const id = field.attr('id');
            const type = field.attr('type');

            // ignora botão
            if (type === 'submit' || type === 'button') return;

            // ignora whatsapp (opcional)
            if (id === 'wpp') return;

            // checkbox (termos)
            if (type === 'checkbox') {
                if (!field.is(':checked')) {
                    allFilled = false;
                }
                return;
            }

            // selects (não pode estar no valor padrão)
            if (field.is('select')) {
                const val = field.val();
                if (!val || val === 'Estado' || val === 'Cidade') {
                    allFilled = false;
                }
                return;
            }

            // inputs normais
            if (field.val().trim() === '') {
                allFilled = false;
            }
        });

        submitBtn.prop('disabled', !allFilled);
    }

    // eventos
    form.on('input change', 'input, select, textarea', function () {
        checkFields();
    });

    // roda ao carregar (autofill)
    checkFields();
});

GLightbox({
    autoplayVideos: true, // Autoplay ao abrir
    loop: true, // Navegar entre vídeos
    closeOnOutsideClick: true, // Fecha clicando fora
    skin: 'clean' // Tema: 'clean' ou 'white'
});

function formSubmit(form) {
    // ✅ Validação de email com .com
    const emailInput = $(form).find('#email');
    const emailValue = emailInput.val().trim();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|com\.br)$/i;

    if (!emailRegex.test(emailValue)) {
        Swal.fire({
            title: 'E-mail inválido',
            text: 'Por favor, informe um e-mail válido terminado em .com',
            icon: 'warning',
            imageUrl: site_url + 'site/img/iconError.png',
            imageWidth: 76,
            imageHeight: 76
        });
        emailInput.focus();
        return false;
    }

    grecaptcha.ready(function () {
        grecaptcha.execute('6LdIr9sZAAAAADlV6TRsdi3aWTuw19tI6ZPilj1-', {
            action: 'submit'
        }).then(function (token) {
            var match = document.cookie.match(new RegExp('(^| )' + '__trf.src' + '=([^;]+)'));
            var traffic_source = match ? match[2] : '';
            var data;
            var contentType = "application/x-www-form-urlencoded";
            var processData = true;

            $('.modalLoader').show();
            data = $(form).serialize() + '&gRecaptchaResponse=' + token + '&traffic_source=' + traffic_source;

            $.ajax({
                data: data,
                type: $(form).attr('method'),
                url: $(form).attr('action'),
                dataType: 'json',
                contentType: contentType,
                processData: processData,
                beforeSend: function () {
                    $(form).find('button').addClass('load');
                    $(form).find('input,button').prop("disabled", true);
                },
                success: function (data) {
                    $('.modalLoader').hide();
                    if (data.status) {
                        Swal.fire({
                            title: (data.title) ? data.title : jsi18n.ajax_success_title,
                            text: data.msgSuccess,  // ✅ text: ao invés de html:
                            imageUrl: site_url + 'site/img/iconSuccess.png',
                            imageWidth: 76,
                            imageHeight: 76
                        });
                        $(form).find('input, button').prop("disabled", false);
                        $(form)[0].reset();
                        $(form).find('button').removeClass('load');

                        // Libera o conteúdo bloqueado na própria página (sem reload)
                        unlockGatedContent();
                    } else {
                        Swal.fire({
                            title: jsi18n.form_invalid_title,
                            text: data.msgWarning,  // ✅ text: aqui também
                            imageUrl: site_url + 'site/img/iconError.png',
                            imageWidth: 76,
                            imageHeight: 76
                        });
                        $(form).find('input,button').prop("disabled", false);
                        $(form).find('button').removeClass('load');
                    }
                },
                error: function (data) {
                    $('.modalLoader').hide();
                    Swal.fire({
                        title: jsi18n.ajax_error_title,
                        text: jsi18n.ajax_error_message,
                        imageUrl: site_url + 'site/img/iconError.png',
                        imageWidth: 76,
                        imageHeight: 76
                    });
                    $(form).find('input,button').prop("disabled", false);
                    $(form).find('button').removeClass('load');
                }
            });
        });
    });
}

/**
 * Conteúdo bloqueado (gated content)
 * Remove o blur/overlay com fade e persiste o estado no localStorage.
 */
function unlockGatedContent() {
    const gate = document.getElementById('gated-content');
    if (!gate || gate.classList.contains('unlocked')) return;

    // Garante que a transição de fade-out rode (caso tenha vindo "sem animação")
    gate.classList.remove('no-transition');
    void gate.offsetWidth; // força reflow para aplicar a transição a partir do estado atual

    gate.classList.add('unlocked');

    try {
        localStorage.setItem('circuito_conteudo_liberado', '1');
    } catch (e) {
        console.warn('Não foi possível persistir o estado de liberação:', e);
    }
}

/**
 * Filtro de Categorias + Load More para Vídeos
 */
function initVideoFilter() {
    const categories = document.querySelectorAll('.categoria');
    const videoCards = document.querySelectorAll('.video-card');
    const loadMoreBtn = document.getElementById('load-more-videos');
    const loadMoreWrapper = document.getElementById('load-more-wrapper');
    const noResults = document.getElementById('no-results');

    if (!categories.length || !videoCards.length) return;

    const itemsPerLoad = 4;
    let currentFilter = 'all';
    let filteredCards = [];
    let currentIndex = 0;

    /**
     * Filtra os cards pela categoria selecionada
     */
    function filterCards(category) {
        currentFilter = category;

        // Atualiza classe active nas categorias
        categories.forEach(cat => {
            cat.classList.toggle('active', cat.dataset.filter === category);
        });

        // Filtra os cards
        filteredCards = category === 'all'
            ? Array.from(videoCards)
            : Array.from(videoCards).filter(card => card.dataset.category === category);

        // Reset de estado
        currentIndex = 0;

        // Esconde todos os cards primeiro
        videoCards.forEach(card => {
            card.classList.remove('visible');
            card.classList.remove('d-block');
            card.classList.add('d-none');
        });

        // Mostra mensagem se não houver resultados
        if (filteredCards.length === 0) {
            noResults.classList.remove('d-none');
            noResults.classList.add('d-block');

            loadMoreWrapper.classList.remove('d-block');
            loadMoreWrapper.classList.add('d-none');

            return;
        }

        // Esconde mensagem "sem resultados"
        noResults.classList.remove('d-block');
        noResults.classList.add('d-none');

        // Mostra o primeiro lote
        showNextBatch();

        // Atualiza visibilidade do botão "Ver mais"
        updateLoadMoreButton();
    }

    /**
     * Mostra o próximo lote de cards
     */
    function showNextBatch() {
        const endIndex = Math.min(currentIndex + itemsPerLoad, filteredCards.length);

        for (let i = currentIndex; i < endIndex; i++) {
            const card = filteredCards[i];

            // Mostra o card
            card.classList.remove('d-none');
            card.classList.add('d-block');

            // Pequeno delay para animação em cascata
            setTimeout(() => {
                card.classList.add('visible');
            }, (i - currentIndex) * 100);
        }

        currentIndex = endIndex;
        updateLoadMoreButton();
    }

    /**
     * Atualiza estado do botão "Ver mais"
     */
    function updateLoadMoreButton() {
        if (!loadMoreBtn) return;

        if (currentIndex >= filteredCards.length) {
            loadMoreWrapper.classList.add('hidden');
        } else {
            loadMoreWrapper.classList.remove('hidden');
            const remaining = filteredCards.length - currentIndex;
            loadMoreBtn.textContent = `Ver mais vídeos`;
        }
    }

    /**
     * Listener para cliques nas categorias
     */
    categories.forEach(category => {
        category.addEventListener('click', function () {
            const filter = this.dataset.filter;
            filterCards(filter);
        });
    });

    /**
     * Listener para o botão "Ver mais"
     */
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            showNextBatch();
        });
    }

    // Inicializa com "Todos"
    filterCards('all');

    console.log(`✅ Filtro de vídeos ativado: ${videoCards.length} cards, ${categories.length} categorias`);
}